module.exports = "pegasus/assets/blocks/column-13-theme4.png";